import {
  CLEAR_GLOBAL_SEARCH,
  CREATE_TEST_CASE_FAILED,
  CREATE_TEST_CASE_LOADING,
  CREATE_TEST_CASE_SUCCESS,
  GET_ALL_USERS_FAILED,
  GET_ALL_USERS_LOADING,
  GET_ALL_USERS_SUCCESS,
  GET_TEST_CASE_FAILED,
  GET_TEST_CASE_LOADING,
  GET_TEST_CASE_SUCCESS,
  GLOBAL_SEARCH_FAILED,
  GLOBAL_SEARCH_LOADING,
  GLOBAL_SEARCH_SUCCESS,
  LINK_TEST_CASE_FAILED,
  LINK_TEST_CASE_LOADING,
  LINK_TEST_CASE_SUCCESS,
  TOGGLE_TEST_LINKING,
  UNLINK_TEST_CASE_FAILED,
  UNLINK_TEST_CASE_LOADING,
  UNLINK_TEST_CASE_SUCCESS
} from "../../actionTypeConstants/ml2.0/testManager";

const initialState = {
  isTestLinked: false,
  globalSearch: {
    loading: false,
    data: [],
    error: ""
  },
  testCase: {
    loading: false,
    data: [],
    error: ""
  },
  createTestCase: {
    loading: false,
    data: [],
    error: ""
  },
  users: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TEST_CASE_SUCCESS: {
      return {
        ...state,
        testCase: {
          ...state.testCase,
          loading: false,
          data: action?.result?.data?.data,
          error: ""
        }
      };
    }

    case GET_TEST_CASE_LOADING: {
      return {
        ...state,
        isTestLinked: false,
        testCase: {
          ...state.testCase,
          loading: true,
          data: [],
          error: ""
        }
      };
    }

    case GET_TEST_CASE_FAILED: {
      return {
        ...state,
        isTestLinked: false,
        testCase: {
          ...state.testCase,
          loading: false,
          data: [],
          error: action?.error?.response
        }
      };
    }

    case GLOBAL_SEARCH_SUCCESS: {
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          loading: false,
          data: action?.result?.data?.data,
          error: ""
        }
      };
    }

    case GLOBAL_SEARCH_LOADING: {
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          loading: true,
          data: [],
          error: ""
        }
      };
    }

    case GLOBAL_SEARCH_FAILED: {
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          loading: false,
          data: [],
          error: action?.error?.response
        }
      };
    }

    case LINK_TEST_CASE_SUCCESS: {
      return {
        ...state,
        isTestLinked: true
      };
    }

    case LINK_TEST_CASE_FAILED: {
      return {
        ...state,
        isTestLinked: false
      };
    }

    case LINK_TEST_CASE_LOADING: {
      return {
        ...state,
        isTestLinked: false
      };
    }

    case UNLINK_TEST_CASE_SUCCESS: {
      return {
        ...state,
        isTestLinked: false
      };
    }

    case UNLINK_TEST_CASE_FAILED: {
      return {
        ...state,
        isTestLinked: true
      };
    }

    case UNLINK_TEST_CASE_LOADING: {
      return {
        ...state,
        isTestLinked: true
      };
    }

    case TOGGLE_TEST_LINKING: {
      return {
        ...state,
        isTestLinked: action.result
      };
    }

    case CLEAR_GLOBAL_SEARCH: {
      return {
        ...state,
        globalSearch: {
          ...state.globalSearch,
          data: []
        }
      };
    }

    case GET_ALL_USERS_FAILED: {
      return {
        ...state,
        users: []
      };
    }

    case GET_ALL_USERS_SUCCESS: {
      return {
        ...state,
        users: action?.result?.data?.data
      };
    }

    case GET_ALL_USERS_LOADING: {
      return {
        ...state,
        users: []
      };
    }

    case CREATE_TEST_CASE_FAILED: {
      return {
        ...state,
        createTestCase: {
          ...state.createTestCase,
          loading: false,
          data: [],
          error: action?.error?.response
        }
      }
    }

    case CREATE_TEST_CASE_LOADING: {  
      return {
        ...state,
        createTestCase: {
          ...state.createTestCase,
          loading: true,
          data: [],
          error: ""
        }
      }
    }

    case CREATE_TEST_CASE_SUCCESS: {
      return {
        ...state,
        createTestCase: {
          ...state.createTestCase,
          loading: false,
          data: action?.result?.data?.data,
          error: ""
        }
      }
    }

    default:
      return state;
  }
}
